import { render } from "./roles-create-edit.html?vue&type=template&id=d48b7fb2&scoped=true&ts=true"
import script from "./roles-create-edit.ts?vue&type=script&lang=ts"
export * from "./roles-create-edit.ts?vue&type=script&lang=ts"

import "./roles-create-edit.scss?vue&type=style&index=0&id=d48b7fb2&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48b7fb2"]])

export default __exports__